// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slideIn {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}
@keyframes slideOut {
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(-100%);
        opacity: 0;
    }
}
.header-bg-color {
    background-color: rgb(236, 234, 232);
}
.header-class {
    min-height: fit-content;
    font-size: 1.2rem;
    font-weight: 400;
    position: static;
    /*  z-index: 9999999999999999999999999999999999999999999999999999999999999999999999999999; */
}
.nav-width{
    width: 100%;   
}
.center-content{
    display: flex;
    justify-content: center;
}
.collapse-btn-size{
    width: fit-content;
    height: fit-content;
}
.btn-border {
    border: 1px solid rgba(0, 0, 0, 0.8);
    border-radius: 5px;
}
.btn-border:hover {
    border: 3px solid rgba(0, 0, 0, 0.6);
}
.login-btn {
    width: fit-content;
}
.login-txt:hover {
    color: orange;
}
.login-txt{
    text-decoration: none;
    color: rgb(65, 63, 62);
}
.dropdown-item {
    position: absolute; 
    padding: 20px;
    top: 60;
    width: 100; 
    border-top: 2px solid rgba(0, 0, 0, 0.8);
}
.dd-item-size{
    height: 50px;
    border: 2px solid red
}
.dd-item-size:hover {
    background-color: rgba(152, 152, 194, 0.726);
    color: orange;
}
.dd-bg-opacity-lg {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100%;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Dim background */
    z-index: 1;
}
.dd-bg-opacity-sm {
    position: fixed;
    right: 0;
    width: 20%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Dim background */
    z-index: 1;
}
select {
    font-weight: bold;
}

select option{
    font-size: 15px;
}
.nav-link-hover-sm{
    height: 40px;
    width: 100%;
    padding-left: 10px;
    padding-top: 5px;
    margin-left: 10px;
    text-decoration: none;
    color: black;
}
.nav-link-hover-sm:hover {
    padding-left: 15px;
    background-color: rgba(0, 0, 255, 0.349);
    color: #ffff;
}
.c-border-top {
    border-top: 2px solid  rgb(138, 132, 132);
}
@media screen and (min-width: 1024px) {
    .nav-list-hover {
        border-bottom: 3px solid blue;
        color: blue;
    }
    .gone-layout-xl {
        display: none;
    }
    .center-width {
        width: 90%;
    }
    .classt{
        display: flex;
        z-index: 1000;
    }
    .container-width {
        display: none;
    }
}
@media screen and (max-width: 1024px) {
    .list-hover-sm {
        display: none;
    }
    .gone-layout-sm{
        display: none;
    }
    .classt{
        display: none;
    }
    .container-width {
        position: fixed;
        width: 80%;
        z-index: 99999;
        left: 0;
        background-color: inherit; 
        font-family: inherit;
    }
    .nav-list-hover {
        width: 100%;
        padding-left: 10px;
        border-bottom: 3px solid blue;
        color: rgb(188, 188, 211);
        background-color: rgba(0, 0, 255, 0.329);
    }
}





/* new btn */


.menu__btn {
  position: relative;
  top: -4px;
  left: 10px;
  width: 26px;
  height: 26px;
  cursor: pointer;
  z-index: 1;
  z-index:10000000000000000000000000000;
}
.menu__btn > span {
  background-color:  black;
  font-weight:bold;
}
.menu__btn > span::before {
  background-color:   black;
}
.menu__btn > span::after { 
  background-color: black;
}
.menu__btn > span,
.menu__btn > span::before,
.menu__btn > span::after {
  display: block;
  position: absolute;
  width: 100%;
  height: 2px;
  transition-duration: .25s;
  z-index:10000000000000000000000000000000;
}
.menu__btn > span::before {
  content: '';
  top: -8px;
  z-index:10000000000000000000000000000000;
}
.menu__btn > span::after {
  content: '';
  top: 8px;
  z-index:10000000000000000000000000000000;
}

#menu__toggle {
    opacity: 0;
    z-index:1000000000000000000000000000000;
}
#menu__toggle:checked + .menu__btn > span {
    transform: rotate(45deg);
    z-index:1000000000000000000000000000000;
}
#menu__toggle:checked + .menu__btn > span::before {
    top: 0;
    transform: rotate(0deg);
    z-index:1000000000000000000000000000000;
}
#menu__toggle:checked + .menu__btn > span::after {
    top: 0;
    transform: rotate(90deg);
    z-index:1000000000000000000000000000000;
}
@media screen and (max-width: 500px) {
    .colorixlogo{
        width: 100px;
        height:30px;
    }
}

@media screen and (min-width: 500px) and (max-width: 800px) {
    .colorixlogo{
        width: 140px;
        height:40px;
        margin-top:-9px;
    }

}

@media screen and (min-width: 800px) and (max-width: 1200px) {
    .colorixlogo{
        width: 160px;
        height:45px;
        margin-top:-13px;
    }
    
}

@media screen and (min-width: 1200px){
    .colorixlogo{
        width: 190px;
        height:55px;
        margin-top:-16px;
    }
        
}
@media screen and (max-width: 500px) {
    .telgadjet{
        font-size: 11px;
        float: left;
        margin-top:3px;
        margin-bottom: 0px;
        margin-left:-20px;
    }
    .selctcustom{
        font-size: 12.5px;
    }
}
@media screen and (min-width: 500px) and (max-width: 800px) {
    .telgadjet{
        font-size: 11px;
        float: left;
        margin-top:3px;
        margin-bottom: 4px;
        margin-left:-20px;

    }
    .selctcustom{
        font-size: 15px;
    }
}
@media screen and (min-width: 800px) and (max-width: 1200px) {
    .telgadjet{
        font-size: 13px;
        float: left;
        margin-top:2px;
        margin-bottom: 9px;
        margin-left:-20px;
    }
    .selctcustom{
        font-size: 15px;
    }
}
@media screen and (min-width: 1200px) {
    .telgadjet{
        font-size: 14px;
        float: left;
        margin-top:-2px;
        margin-bottom: 16px;
        margin-left:-20px;

    }
    .selctcustom{
        font-size: 15px;
    }
}

  .marquee {
    width: 70%; /* Adjust as needed */
    overflow: hidden;
    white-space: nowrap;
    position: relative;
    margin-left:-20px;
  }
  
  .scroll-track {
    display: flex;
    min-width: 140%; /* ensure room for two full copies */
    animation: scroll-right 15s linear infinite;
  }
  
  .scroll-text {
    flex: 0 0 100%;
    font-size: 20px;
    white-space: nowrap;
    text-align: center;
  }

  @keyframes scroll-right {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0%);
    }
  }

  .search-container {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease, opacity 0.4s ease;
    opacity: 0;
    background-color: #f1f1f1;
    padding: 0 20px;
  }
  
  .search-container.show {
    max-height: 100px; /* adjust as needed */
    opacity: 1;
    padding: 10px 20px;
  }
  @media screen and (max-width: 500px) {
    .search-input {
        width: 100%;
        padding: 10px;
        font-size: 16px;
        border-radius: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
      }
      .search-button {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        cursor: pointer;
        font-size: 18px;
      }
  }
  @media screen and (min-width: 500px) and (max-width: 800px) {
    .search-input {
        width: 70%;
        padding: 10px;
        font-size: 16px;
        margin-left:15%;
        border-radius: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
      }
      .search-button {
        position: absolute;
        right: 15%;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        cursor: pointer;
        font-size: 18px;
      }
  }
  @media screen and (min-width: 800px) and (max-width: 1200px) {
    .search-input {
        width: 60%;
        padding: 10px;
        font-size: 16px;
        margin-left:20%;
        border-radius: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
      }
      .search-button {
        position: absolute;
        right: 20%;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        cursor: pointer;
        font-size: 18px;
      }
  }
  @media screen and (min-width: 1200px) {
    .search-input {
        width: 60%;
        padding: 10px;
        font-size: 16px;
        margin-left:20%;
        border-radius: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
      }
      .search-button {
        position: absolute;
        right: 20%;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        cursor: pointer;
        font-size: 18px;
      }
  }
 
.search-form {
    position: relative;
    width: 100%;
  }
  

  
`, "",{"version":3,"sources":["webpack://./src/components/style/HeaderComponent.css"],"names":[],"mappings":"AAAA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;AACA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,4BAA4B;QAC5B,UAAU;IACd;AACJ;AACA;IACI,oCAAoC;AACxC;AACA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,4FAA4F;AAChG;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,UAAU;IACV,wCAAwC;AAC5C;AACA;IACI,YAAY;IACZ;AACJ;AACA;IACI,4CAA4C;IAC5C,aAAa;AACjB;AACA;IACI,eAAe;IACf,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,oCAAoC,EAAE,mBAAmB;IACzD,UAAU;AACd;AACA;IACI,eAAe;IACf,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,oCAAoC,EAAE,mBAAmB;IACzD,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;AAChB;AACA;IACI,yCAAyC;AAC7C;AACA;IACI;QACI,6BAA6B;QAC7B,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;QACb,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;QACf,UAAU;QACV,cAAc;QACd,OAAO;QACP,yBAAyB;QACzB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,6BAA6B;QAC7B,yBAAyB;QACzB,wCAAwC;IAC5C;AACJ;;;;;;AAMA,YAAY;;;AAGZ;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,qCAAqC;AACvC;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,SAAS;EACT,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;IACI,UAAU;IACV,uCAAuC;AAC3C;AACA;IACI,wBAAwB;IACxB,uCAAuC;AAC3C;AACA;IACI,MAAM;IACN,uBAAuB;IACvB,uCAAuC;AAC3C;AACA;IACI,MAAM;IACN,wBAAwB;IACxB,uCAAuC;AAC3C;AACA;IACI;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;AAEJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;AAEJ;AACA;IACI;QACI,eAAe;QACf,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,eAAe;QACf,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,iBAAiB;;IAErB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;QACf,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;QACf,WAAW;QACX,eAAe;QACf,mBAAmB;QACnB,iBAAiB;;IAErB;IACA;QACI,eAAe;IACnB;AACJ;;EAEE;IACE,UAAU,EAAE,qBAAqB;IACjC,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe,EAAE,oCAAoC;IACrD,2CAA2C;EAC7C;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;IACV,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,iBAAiB,EAAE,qBAAqB;IACxC,UAAU;IACV,kBAAkB;EACpB;EACA;IACE;QACI,WAAW;QACX,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;MACpB;MACA;QACE,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,2BAA2B;QAC3B,uBAAuB;QACvB,YAAY;QACZ,eAAe;QACf,eAAe;MACjB;EACJ;EACA;IACE;QACI,UAAU;QACV,aAAa;QACb,eAAe;QACf,eAAe;QACf,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;MACpB;MACA;QACE,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,2BAA2B;QAC3B,uBAAuB;QACvB,YAAY;QACZ,eAAe;QACf,eAAe;MACjB;EACJ;EACA;IACE;QACI,UAAU;QACV,aAAa;QACb,eAAe;QACf,eAAe;QACf,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;MACpB;MACA;QACE,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,2BAA2B;QAC3B,uBAAuB;QACvB,YAAY;QACZ,eAAe;QACf,eAAe;MACjB;EACJ;EACA;IACE;QACI,UAAU;QACV,aAAa;QACb,eAAe;QACf,eAAe;QACf,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;MACpB;MACA;QACE,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,2BAA2B;QAC3B,uBAAuB;QACvB,YAAY;QACZ,eAAe;QACf,eAAe;MACjB;EACJ;;AAEF;IACI,kBAAkB;IAClB,WAAW;EACb","sourcesContent":["@keyframes slideIn {\n    from {\n        transform: translateY(-100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n@keyframes slideOut {\n    from {\n        transform: translateY(0);\n        opacity: 1;\n    }\n    to {\n        transform: translateY(-100%);\n        opacity: 0;\n    }\n}\n.header-bg-color {\n    background-color: rgb(236, 234, 232);\n}\n.header-class {\n    min-height: fit-content;\n    font-size: 1.2rem;\n    font-weight: 400;\n    position: static;\n    /*  z-index: 9999999999999999999999999999999999999999999999999999999999999999999999999999; */\n}\n.nav-width{\n    width: 100%;   \n}\n.center-content{\n    display: flex;\n    justify-content: center;\n}\n.collapse-btn-size{\n    width: fit-content;\n    height: fit-content;\n}\n.btn-border {\n    border: 1px solid rgba(0, 0, 0, 0.8);\n    border-radius: 5px;\n}\n.btn-border:hover {\n    border: 3px solid rgba(0, 0, 0, 0.6);\n}\n.login-btn {\n    width: fit-content;\n}\n.login-txt:hover {\n    color: orange;\n}\n.login-txt{\n    text-decoration: none;\n    color: rgb(65, 63, 62);\n}\n.dropdown-item {\n    position: absolute; \n    padding: 20px;\n    top: 60;\n    width: 100; \n    border-top: 2px solid rgba(0, 0, 0, 0.8);\n}\n.dd-item-size{\n    height: 50px;\n    border: 2px solid red\n}\n.dd-item-size:hover {\n    background-color: rgba(152, 152, 194, 0.726);\n    color: orange;\n}\n.dd-bg-opacity-lg {\n    position: fixed;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin-bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5); /* Dim background */\n    z-index: 1;\n}\n.dd-bg-opacity-sm {\n    position: fixed;\n    right: 0;\n    width: 20%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* Dim background */\n    z-index: 1;\n}\nselect {\n    font-weight: bold;\n}\n\nselect option{\n    font-size: 15px;\n}\n.nav-link-hover-sm{\n    height: 40px;\n    width: 100%;\n    padding-left: 10px;\n    padding-top: 5px;\n    margin-left: 10px;\n    text-decoration: none;\n    color: black;\n}\n.nav-link-hover-sm:hover {\n    padding-left: 15px;\n    background-color: rgba(0, 0, 255, 0.349);\n    color: #ffff;\n}\n.c-border-top {\n    border-top: 2px solid  rgb(138, 132, 132);\n}\n@media screen and (min-width: 1024px) {\n    .nav-list-hover {\n        border-bottom: 3px solid blue;\n        color: blue;\n    }\n    .gone-layout-xl {\n        display: none;\n    }\n    .center-width {\n        width: 90%;\n    }\n    .classt{\n        display: flex;\n        z-index: 1000;\n    }\n    .container-width {\n        display: none;\n    }\n}\n@media screen and (max-width: 1024px) {\n    .list-hover-sm {\n        display: none;\n    }\n    .gone-layout-sm{\n        display: none;\n    }\n    .classt{\n        display: none;\n    }\n    .container-width {\n        position: fixed;\n        width: 80%;\n        z-index: 99999;\n        left: 0;\n        background-color: inherit; \n        font-family: inherit;\n    }\n    .nav-list-hover {\n        width: 100%;\n        padding-left: 10px;\n        border-bottom: 3px solid blue;\n        color: rgb(188, 188, 211);\n        background-color: rgba(0, 0, 255, 0.329);\n    }\n}\n\n\n\n\n\n/* new btn */\n\n\n.menu__btn {\n  position: relative;\n  top: -4px;\n  left: 10px;\n  width: 26px;\n  height: 26px;\n  cursor: pointer;\n  z-index: 1;\n  z-index:10000000000000000000000000000;\n}\n.menu__btn > span {\n  background-color:  black;\n  font-weight:bold;\n}\n.menu__btn > span::before {\n  background-color:   black;\n}\n.menu__btn > span::after { \n  background-color: black;\n}\n.menu__btn > span,\n.menu__btn > span::before,\n.menu__btn > span::after {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 2px;\n  transition-duration: .25s;\n  z-index:10000000000000000000000000000000;\n}\n.menu__btn > span::before {\n  content: '';\n  top: -8px;\n  z-index:10000000000000000000000000000000;\n}\n.menu__btn > span::after {\n  content: '';\n  top: 8px;\n  z-index:10000000000000000000000000000000;\n}\n\n#menu__toggle {\n    opacity: 0;\n    z-index:1000000000000000000000000000000;\n}\n#menu__toggle:checked + .menu__btn > span {\n    transform: rotate(45deg);\n    z-index:1000000000000000000000000000000;\n}\n#menu__toggle:checked + .menu__btn > span::before {\n    top: 0;\n    transform: rotate(0deg);\n    z-index:1000000000000000000000000000000;\n}\n#menu__toggle:checked + .menu__btn > span::after {\n    top: 0;\n    transform: rotate(90deg);\n    z-index:1000000000000000000000000000000;\n}\n@media screen and (max-width: 500px) {\n    .colorixlogo{\n        width: 100px;\n        height:30px;\n    }\n}\n\n@media screen and (min-width: 500px) and (max-width: 800px) {\n    .colorixlogo{\n        width: 140px;\n        height:40px;\n        margin-top:-9px;\n    }\n\n}\n\n@media screen and (min-width: 800px) and (max-width: 1200px) {\n    .colorixlogo{\n        width: 160px;\n        height:45px;\n        margin-top:-13px;\n    }\n    \n}\n\n@media screen and (min-width: 1200px){\n    .colorixlogo{\n        width: 190px;\n        height:55px;\n        margin-top:-16px;\n    }\n        \n}\n@media screen and (max-width: 500px) {\n    .telgadjet{\n        font-size: 11px;\n        float: left;\n        margin-top:3px;\n        margin-bottom: 0px;\n        margin-left:-20px;\n    }\n    .selctcustom{\n        font-size: 12.5px;\n    }\n}\n@media screen and (min-width: 500px) and (max-width: 800px) {\n    .telgadjet{\n        font-size: 11px;\n        float: left;\n        margin-top:3px;\n        margin-bottom: 4px;\n        margin-left:-20px;\n\n    }\n    .selctcustom{\n        font-size: 15px;\n    }\n}\n@media screen and (min-width: 800px) and (max-width: 1200px) {\n    .telgadjet{\n        font-size: 13px;\n        float: left;\n        margin-top:2px;\n        margin-bottom: 9px;\n        margin-left:-20px;\n    }\n    .selctcustom{\n        font-size: 15px;\n    }\n}\n@media screen and (min-width: 1200px) {\n    .telgadjet{\n        font-size: 14px;\n        float: left;\n        margin-top:-2px;\n        margin-bottom: 16px;\n        margin-left:-20px;\n\n    }\n    .selctcustom{\n        font-size: 15px;\n    }\n}\n\n  .marquee {\n    width: 70%; /* Adjust as needed */\n    overflow: hidden;\n    white-space: nowrap;\n    position: relative;\n    margin-left:-20px;\n  }\n  \n  .scroll-track {\n    display: flex;\n    min-width: 140%; /* ensure room for two full copies */\n    animation: scroll-right 15s linear infinite;\n  }\n  \n  .scroll-text {\n    flex: 0 0 100%;\n    font-size: 20px;\n    white-space: nowrap;\n    text-align: center;\n  }\n\n  @keyframes scroll-right {\n    from {\n      transform: translateX(-100%);\n    }\n    to {\n      transform: translateX(0%);\n    }\n  }\n\n  .search-container {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.4s ease, opacity 0.4s ease;\n    opacity: 0;\n    background-color: #f1f1f1;\n    padding: 0 20px;\n  }\n  \n  .search-container.show {\n    max-height: 100px; /* adjust as needed */\n    opacity: 1;\n    padding: 10px 20px;\n  }\n  @media screen and (max-width: 500px) {\n    .search-input {\n        width: 100%;\n        padding: 10px;\n        font-size: 16px;\n        border-radius: 10px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n      }\n      .search-button {\n        position: absolute;\n        right: 5px;\n        top: 50%;\n        transform: translateY(-50%);\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        font-size: 18px;\n      }\n  }\n  @media screen and (min-width: 500px) and (max-width: 800px) {\n    .search-input {\n        width: 70%;\n        padding: 10px;\n        font-size: 16px;\n        margin-left:15%;\n        border-radius: 10px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n      }\n      .search-button {\n        position: absolute;\n        right: 15%;\n        top: 50%;\n        transform: translateY(-50%);\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        font-size: 18px;\n      }\n  }\n  @media screen and (min-width: 800px) and (max-width: 1200px) {\n    .search-input {\n        width: 60%;\n        padding: 10px;\n        font-size: 16px;\n        margin-left:20%;\n        border-radius: 10px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n      }\n      .search-button {\n        position: absolute;\n        right: 20%;\n        top: 50%;\n        transform: translateY(-50%);\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        font-size: 18px;\n      }\n  }\n  @media screen and (min-width: 1200px) {\n    .search-input {\n        width: 60%;\n        padding: 10px;\n        font-size: 16px;\n        margin-left:20%;\n        border-radius: 10px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n      }\n      .search-button {\n        position: absolute;\n        right: 20%;\n        top: 50%;\n        transform: translateY(-50%);\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        font-size: 18px;\n      }\n  }\n \n.search-form {\n    position: relative;\n    width: 100%;\n  }\n  \n\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
